import { jsx as k } from "react/jsx-runtime";
import { createContext as s, useContext as l, useState as d } from "react";
import { createEventEmitter as m } from "@made-people/grease-event-emitter";
import { toEmailAddressOrUndefined as b } from "@made-people/types-email-address";
const y = {
  subscribe: "subscribe"
}, v = s(void 0), _ = (t) => /* @__PURE__ */ k(v.Provider, { value: t, children: t.children }), f = () => {
  const t = l(v);
  return t || { additionalData: void 0 };
}, h = m(), S = s(
  void 0
), B = (t) => {
  const o = t.backInStockEventEmitter ?? h, r = {
    backInStockClient: t.backInStockClientDriver,
    backInStockEventEmitter: o
  };
  return /* @__PURE__ */ k(S.Provider, { value: r, children: t.children });
};
B.displayName = "BackInStockProvider";
const w = () => {
  const t = l(S);
  if (!t)
    throw new Error("useBackInStock must be used within a BackInStockProvider");
  return t;
}, A = (t) => {
  const { backInStockClient: o, backInStockEventEmitter: r } = w(), { additionalData: u } = f(), [E, c] = d(void 0), [I, n] = d("default");
  return {
    loadingState: I,
    error: E,
    execute: async (a) => {
      if (c(void 0), b(a.email) === void 0) {
        const e = new Error("Back_In_Stock_Method_Invalid_Email");
        throw c(e), e;
      }
      n("loading");
      try {
        await o[t](a), n("complete"), r.emit(t, {
          payload: a,
          additionalData: u
        });
      } catch (e) {
        n("default");
        const i = e instanceof Error ? e : new Error(`${e}`);
        throw c(i), i;
      } finally {
        n("default");
      }
    }
  };
};
export {
  _ as BackInStockEventAdditionalDataProvider,
  B as BackInStockProvider,
  y as backInStockClientMethods,
  h as backInStockEventEmitter,
  w as useBackInStock,
  f as useBackInStockEventAdditionalData,
  A as useBackInStockMethod
};
